<template>
  <div class="text-primary font-weight-bolder quote-route-button">
    <b-button
      size="sm"
      variant="primary"
      class="font-weight-bolder"
      :to="handleRouter(quote)"
    >
      #{{ quote.folio }}
    </b-button>
    <small
      v-if="showNickname"
      class="quote-nickname d-block mt-25"
    >
      {{ quote.nickname }}
    </small>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import resolveQuoteRoute from '@/utils/quoteRoute'

export default {
  components: {},
  props: {
    quote: {
      type: Object,
      default() {
        return {}
      },
    },
  },
  data() {
    return {}
  },

  computed: {
    ...mapGetters('auth', ['currentUser']),
    showNickname() {
      return ['admin', 'customer'].includes(this.currentUser?.role_name) && this.quote.nickname
    },
  },

  methods: {
    handleRouter(quote) {
      return resolveQuoteRoute({
        quote,
        currentUser: this.currentUser,
        routeParams: this.$route.params,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.custom-padding {
  padding: 3px !important;
}

.quote-route-button {
  line-height: 1.1;
}

.quote-nickname {
  color: #6c757d;
  font-weight: 600;
}
</style>
